import _styled from "@emotion/styled-base"; // external dependencies

import React, { useEffect, useRef } from 'react';

// styled components
var Input = _styled("input", {
  target: "ey8dv5g0",
  label: "Input"
})("box-sizing:border-box;color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.text;
}, ";font-size:16px;height:30px;margin:0;width:100%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JbnRlcmFjdGl2ZU1hcC9OZWFyWW91U2VhcmNoLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNMEIiLCJmaWxlIjoiLi4vLi4vc3JjL0ludGVyYWN0aXZlTWFwL05lYXJZb3VTZWFyY2guanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLy8gZXh0ZXJuYWwgZGVwZW5kZW5jaWVzXG5pbXBvcnQgUmVhY3QsIHsgdXNlRWZmZWN0LCB1c2VSZWYgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgZnVuYywgc3RyaW5nIH0gZnJvbSAncHJvcC10eXBlcydcblxuLy8gc3R5bGVkIGNvbXBvbmVudHNcbmNvbnN0IElucHV0ID0gc3R5bGVkLmlucHV0YFxuXHRib3gtc2l6aW5nOiBib3JkZXItYm94O1xuXHRjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb2xvcnMudGV4dH07XG5cdGZvbnQtc2l6ZTogMTZweDtcblx0aGVpZ2h0OiAzMHB4O1xuXHRtYXJnaW46IDA7XG5cdHdpZHRoOiAxMDAlO1xuYFxuXG5OZWFyWW91U2VhcmNoLnByb3BUeXBlcyA9IHtcblx0b25QbGFjZXNDaGFuZ2VkOiBmdW5jLFxuXHRwbGFjZWhvbGRlcjogc3RyaW5nLFxufVxuXG4vKipcbiAqIE5lYXJZb3VTZWFyY2hcbiAqXG4gKiBTZWFyY2hib3ggZm9yIHRoZSBsaXN0IG9mIHNlcnZpY2VzIHRoYXQgYXBwZWFycyB0byB0aGUgc2lkZSBvZiB0aGUgXCJOZWFyIFlvdVwiIG1hcFxuICovXG5leHBvcnQgZnVuY3Rpb24gTmVhcllvdVNlYXJjaCh7IG9uUGxhY2VzQ2hhbmdlZCwgcGxhY2Vob2xkZXIgfSkge1xuXHRjb25zdCBpbnB1dFJlZiA9IHVzZVJlZihudWxsKVxuXG5cdHVzZUVmZmVjdCgoKSA9PiB7XG5cdFx0Y29uc3QgdXBkYXRlUGxhY2VkQ2hhbmdlZCA9ICgpID0+IHtcblx0XHRcdGlmIChvblBsYWNlc0NoYW5nZWQpIHtcblx0XHRcdFx0b25QbGFjZXNDaGFuZ2VkKHNlYXJjaEJveC5nZXRQbGFjZXMoKSlcblx0XHRcdH1cblx0XHR9XG5cblx0XHRjb25zdCBzZWFyY2hCb3ggPSBuZXcgd2luZG93Lmdvb2dsZS5tYXBzLnBsYWNlcy5TZWFyY2hCb3goaW5wdXRSZWYuY3VycmVudClcblx0XHRjb25zdCBzZWFyY2hCb3hMaXN0ZW5lciA9IHNlYXJjaEJveC5hZGRMaXN0ZW5lcigncGxhY2VzX2NoYW5nZWQnLCB1cGRhdGVQbGFjZWRDaGFuZ2VkKVxuXG5cdFx0cmV0dXJuICgpID0+IHdpbmRvdy5nb29nbGUubWFwcy5ldmVudC5yZW1vdmVMaXN0ZW5lcihzZWFyY2hCb3hMaXN0ZW5lcilcblx0fSwgW29uUGxhY2VzQ2hhbmdlZF0pXG5cblx0cmV0dXJuIDxJbnB1dCByZWY9e2lucHV0UmVmfSBwbGFjZWhvbGRlcj17cGxhY2Vob2xkZXJ9IHR5cGU9XCJ0ZXh0XCIgLz5cbn1cbiJdfQ== */"));

/**
 * NearYouSearch
 *
 * Searchbox for the list of services that appears to the side of the "Near You" map
 */
export function NearYouSearch(_ref2) {
  var onPlacesChanged = _ref2.onPlacesChanged,
      placeholder = _ref2.placeholder;
  var inputRef = useRef(null);
  useEffect(function () {
    var updatePlacedChanged = function updatePlacedChanged() {
      if (onPlacesChanged) {
        onPlacesChanged(searchBox.getPlaces());
      }
    };

    var searchBox = new window.google.maps.places.SearchBox(inputRef.current);
    var searchBoxListener = searchBox.addListener('places_changed', updatePlacedChanged);
    return function () {
      return window.google.maps.event.removeListener(searchBoxListener);
    };
  }, [onPlacesChanged]);
  return /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    placeholder: placeholder,
    type: "text"
  });
}